import BaseContainer from './base_container';

export default BaseContainer;
